import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { Card, CardContent, Typography, Button, Grid } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveIcon from "@mui/icons-material/Remove";

import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useNavigate } from "react-router-dom";
import imgurl from "./assests/images/imgurl";
import "./assests/css/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductStepper from "./components/CartPage";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { addToCart, getAllProducts } from "./api/api";
import { useEffect } from "react";
import Sidebar from "./components/Sidebar";
import AlertComp from "./Alert";

function ProductDetls() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);
  const [cart, setCart] = useState([]);

  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("cart");
  const [filteredProducts, setFilteredProducts] = useState([]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: true,
    // prevArrow: true
  };

  useEffect(() => {
    getAllProducts().then(setProducts);
  }, []);

  console.log(products, "::>>products>>");

  // const handleAddToCart = async (product, quantity) => {
  //   setalertopen(true)

  //   if (product.variants.length > 0 && quantity > 0) {
  //     await addToCart(product.id, product.variants[0].id, quantity);
  //         setTimeout(() => {
  //           setalertopen(false)
  //         }, 4000);
  //     // alert("Product added to cart");
  //   } else {

  //     alert("Invalid quantity or no variants available");
  //   }
  // };

  const handleAddToCart = (product, quantity) => {
    setalertopen(true);

    if (product.variants.length > 0 && quantity > 0) {
      // Get current cart from localStorage
      let cart = JSON.parse(localStorage.getItem("cart")) || [];

      // Check if the product with the same productId and variantId exists in the cart
      const existingCartItemIndex = cart.findIndex(
        (item) =>
          item.productId === product.id &&
          item.variantId === product.variants[0].id
      );

      if (existingCartItemIndex !== -1) {
        // If the product already exists, just increase its quantity
        cart[existingCartItemIndex].quantity += quantity;
      } else {
        // If the product doesn't exist, add a new item to the cart
        const cartItem = {
          productId: product.id,
          variantId: product.variants[0].id,
          quantity: quantity,
        };
        cart.push(cartItem);
      }

      // Save the updated cart back to localStorage
      localStorage.setItem("cart", JSON.stringify(cart));

      setTimeout(() => {
        setalertopen(false);
      }, 4000);
    } else {
      alert("Invalid quantity or no variants available");
    }
  };

  const handleQuantityChange = (productId, currentQuantity) => {
    console.log("hi");
    setQuantities((prevQuantities) => {
      const newQuantity = (prevQuantities[productId] || 0) + currentQuantity;
      if (newQuantity >= 0) {
        return { ...prevQuantities, [productId]: newQuantity };
      }
      return prevQuantities;
    });
  };

  const next = () => {
    if (activeIndex === 4) {
      navigate("/taketest", { replace: true });
    } else {
      sliderRef.current.slickNext();
    }
  };

  const previous = () => {
    if (activeIndex === 0) {
      navigate("/loginpage", { replace: true });
    } else {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <>
      <div className="photo-container productDetailsSection">
        {/* <Slider ref={sliderRef} {...settings}> */}
        {/* Slide 1 */}
        <div key={1}>
          <div className="productdetls">
            {/* Back button */}
            <Grid container spacing={0} alignItems="center">
              <Grid item xs={1}></Grid>
              <Grid
                item
                xs={10}
                className="d-flex justify-content-center align-items-center"
              >
                <Typography variant="h6" className="title">
                  Product Details
                </Typography>
              </Grid>
              <Grid xs={1}>
                <Sidebar />
              </Grid>
            </Grid>

            {products &&
              products
                .filter((data) => data.id == "7612342304816")
                .map((data, index) => {
                  console.log(data, "::>>dattatata");

                  return (
                    <Card className="productcard" key={data.id}>
                      <CardContent className="productcardcontent">
                        <Grid container className="productgrid">
                          <Grid item xs={12} className="producttext">
                            <p className="p-header">{data?.title}</p>
                            {/* <p className="p-sub">
                              Topical Anti-Androgens And Growth Boosters
                            </p> */}
                          </Grid>

                          {/* <Grid item xs={12} className="productimg">
                            <img
                              src={data.images[0]?.src}
                              alt="Tablet"
                              className="Tablet w-100"
                            />
                          </Grid> */}
                          <Grid item xs={12} className="productimg">
                            <Slider {...settings}>
                              {data.images.map((image, index) => (
                                <div key={index}>
                                  <img
                                    src={image?.src}
                                    alt={`Product Image ${index + 1}`}
                                    className="Tablet w-100"
                                  />
                                </div>
                              ))}
                            </Slider>
                          </Grid>

                          <Grid item xs={12} className="productlastsec">
                            <p
                              className="productText"
                              dangerouslySetInnerHTML={{
                                __html: data.body_html,
                              }}
                            ></p>
                            <p className="countPrice">
                              €{data.variants[0]?.price || "N/A"}
                            </p>
                            <p className="taxesLabel">Taxes included.</p>
                          </Grid>
                        </Grid>
                      </CardContent>
                      {/* Navigation Buttons */}
                      <Grid container spacing={1} className="btnssection">
                        <Grid
                          item
                          xs={8}
                          className="d-flex justify-content-start align-items-center addTocartBtn"
                        >
                          <Button
                            variant="contained"
                            className="outlinedButton w-60"
                            onClick={() =>
                              handleAddToCart(data, quantities[data.id] || 0)
                            }
                          >
                            Add to Cart
                          </Button>
                        </Grid>

                        <Grid
                          item
                          xs={4}
                          className="d-flex justify-content-end align-items-center"
                        >
                          <div className="sliderButton gap-10px">
                            <div className="prevbtn">
                              <button variant="contained quantityIcons">
                                <RemoveIcon
                                  onClick={() =>
                                    handleQuantityChange(data.id, -1)
                                  }
                                />
                              </button>
                            </div>
                            <span style={{ margin: "0 10px" }}>
                              {quantities[data.id] || 0}
                            </span>
                            <div className="nextbtn">
                              <button variant="contained quantityIcons">
                                <AddIcon
                                  onClick={() =>
                                    handleQuantityChange(data.id, 1)
                                  }
                                />
                              </button>
                            </div>
                          </div>
                        </Grid>
                      </Grid>

                      <div className="d-flex justify-content-center align-items-center flex-direction-column mt-20px buy-now-btn">
                        <Button
                          variant="contained"
                          className="commonButton addTocartBtn "
                          onClick={() => navigate("/cartpage")}
                        >
                          Go to Cart
                        </Button>
                      </div>
                    </Card>
                  );
                })}

            {/* <Card className="productcard">
              <CardContent className="productcardcontent">
                <Grid container className="productgrid">
                  <Grid item xs={12} className="producttext">
                    <p className="p-header">REVITALIZE YOUR HAIR!</p>
                    <p className="p-sub">Topical Anti-Androgens And Growth Boosters</p>
                  </Grid>

                  <Grid item xs={12} className="productimg">
                    <img src={imgurl.product1} alt="Tablet" className="Tablet" />
                  </Grid>

                  <Grid item xs={12} className="productlastsec">
                    <p>Personalised Hair Compound</p>
                    <p className="countPrice">$98.99</p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card> */}
          </div>
        </div>

        {/* Additional slides can be added here */}
        {/* <div key={2}>
            <Grid container spacing={0} alignItems="center">
              <Grid item xs={1}>
                <div className="d-flex justify-content-start align-items-center">
                  <span className="backButtonDiv">
                    <ArrowBackOutlinedIcon className="arrowBackBtn" />
                  </span>
                </div>
              </Grid>
              <Grid
                item
                xs={11}
                className="d-flex justify-content-center align-items-center"
              >
                <Typography variant="h6" className="title">
                  Check Out
                </Typography>
              </Grid>
            </Grid>
            <div>
              <ProductStepper></ProductStepper>
            </div>
          </div> */}
        {/* </Slider> */}
        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      </div>
    </>
  );
}

export default ProductDetls;
